import { useCurrentSite } from '@hotjar/site';
import { useCurrentUser } from '@hotjar/user';
import { getLimitsByFeatureGroup } from '@hotjar/feature-flags';
import { upsell } from '@hotjar/webapp/domains/revenue/upsell';
import { noop } from '@hotjar/webapp/lib/function';
import { navigateTo } from '@hotjar/webapp/utils/routing';
import { SURVEY_TEMPLATES } from '@hotjar/webapp/constants/routes';
import { useCallback } from 'react';
import { useToolsCountQuery } from '..';

export const useCreateSurvey = (): (() => void) => {
  const { data: site } = useCurrentSite();
  const { data: surveysCount } = useToolsCountQuery(site, 'surveys');
  const { data: user } = useCurrentUser();

  return useCallback(() => {
    if (!site) {
      throw Error('No current site provided');
    }
    if (!user) {
      throw Error('No current user provided');
    }
    const plan = site.effectiveAskPlan || site.effectivePlan;
    if (!plan) {
      throw Error('No site plan provided');
    }

    const limit = getLimitsByFeatureGroup('surveys', plan);
    if (surveysCount && limit && surveysCount >= limit) {
      upsell({ site, referrer: 'polls.limit.reached' }).catch(noop);
      return;
    }

    navigateTo(SURVEY_TEMPLATES.BASE.path, { siteId: site.id });
  }, [site, user, surveysCount]);
};
